<h2 mat-dialog-title>View Attachment</h2>
<div mat-dialog-content>
	<div class="row">
		<div class="col-12">
			<img *ngIf="data;" class="img-fluid" [src]="data.attachment.url">
	</div>
</div>